import { render, staticRenderFns } from "./recorderList.vue?vue&type=template&id=f63001a2&scoped=true&"
import script from "./recorderList.vue?vue&type=script&lang=js&"
export * from "./recorderList.vue?vue&type=script&lang=js&"
import style0 from "./recorderList.vue?vue&type=style&index=0&id=f63001a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63001a2",
  null
  
)

export default component.exports